import React from "react";
import { useParams } from "react-router-dom";
import StaffList from "../../components/staff/StaffList";

const Staff = () => {
  let { method } = useParams();

  return <>{method == "list" && <StaffList />}</>;
};

export default Staff;
